<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-08 09:38:40
 * @LastEditors: shenlin
 * @LastEditTime: 2022-10-13 14:46:49
-->
<template>
  <div class="contain">
    <!-- <section class="head">
      <img src="@/assets/images/企业列表.png" alt="" />
    </section> -->
    <section class="box">
      <div class="box_head">
        <el-select
          ref="refSelect"
          v-model="value"
          multiple
          placeholder="请选择"
          filterable
          popper-class="left-select"
          @change="onChoice"
          @remove-tag="removeTagItem"
        >
          <el-option
            v-for="item in labelList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="box_content">
        <el-input
          v-model="key"
          placeholder="请输入搜索企业"
          popper-class="left-select"
          clearable
          @clear="onChoiceEnt"
        >
          <!-- <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.entName"
            :value="item.creditCode"
          >
          </el-option> -->
          <i
            slot="prefix"
            class="el-input__icon el-icon-search"
            @click="onChoiceEnt"
          ></i>
          <template slot="append"
            ><span @click="onChoiceEnt">搜 索</span></template
          >
        </el-input>
        <div class="box_text">共搜索到 {{ number }} 家企业</div>
        <div class="box_content_view">
          <ul
            class="infinite-list"
            v-infinite-scroll="load"
            infinite-scroll-immediate="false"
            style="overflow: auto; margin-top: 0; padding: 0"
          >
            <li
              v-for="(item, index) in entList"
              :key="index"
              :class="[
                'box_content_ent',
                currentIndex == index ? 'active' : ''
              ]"
              @click="onGoEnt(item, index)"
            >
              <img src="@/assets/images/公司icon@2x.png" alt="" />
              <div>
                {{ item.entName }}
              </div>
            </li>
          </ul>
        </div>
        <div v-if="!entList.length" class="noList">
          <img src="@/assets/images/无搜索企业空状态.png" alt="" />
          <div>暂未搜索到任何企业</div>
          <div>请选择其他标签</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {
  labelList,
  getLabelEntList,
  getLabelEntList2
} from '@api/cockpit/index'
import alert from 'gdt-jsapi/alert'
export default {
  computed: {},
  components: {},
  data() {
    return {
      value: [],
      labelList: [],
      number: 0,
      entList: [],
      remark: [],
      key: null,
      loading: false,
      // options: [],
      labelId: null,
      currentIndex: null,
      num: 1
    }
  },
  watch: {
    selectLabelIdList: {
      handler(val) {
        val.map(k => {
          if (!this.value.includes(k)) {
            this.value.push(k)
            this.remoteMethod()
            this.onChoice(this.value)
          }
        })
      },
      deep: true
    },
    reverseSelectionItem(val) {
      let index = this.value.findIndex(item => item == val.join(''))
      if (index > -1) {
        this.value.splice(index, 1)
        this.remoteMethod()
        this.onChoice(this.value)
      }
    }
  },
  created() {
    this.getLabelList()
  },
  props: {
    selectLabelIdList: {
      type: Array,
      default: () => []
    },
    reverseSelectionItem: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    if (this.selectLabelIdList.length) {
      this.value = this.selectLabelIdList
    }
  },
  methods: {
    // 获取标签
    getLabelList() {
      labelList().then(res => {
        if (res.data.code == '0000') {
          this.labelList = res.data.data || []
          this.value = [this.labelList[0].id]
          this.onChoice(this.value)
          // this.remoteMethod()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 根据标签获取企业
    remoteMethod() {
      this.loading = true
      getLabelEntList({
        labelCode: this.value,
        key: this.key
      }).then(res => {
        if (res.data.code == '0000') {
          this.loading = false
          // const num = Math.ceil(res.data.data.length / 1000)
          // console.log(num)
          this.$emit('getEntList', Object.freeze(res.data.data))
        } else {
          this.loading = false
          this.$message.error(res.msg)
        }
      })
    },
    load() {
      getLabelEntList2({
        labelCode: this.value,
        key: this.key,
        pageNum: this.num
      }).then(res => {
        if (res.data.code == '0000') {
          this.num = this.num + 1
          this.number = res.data.data.totalRecord || 0
          // console.log(res.data.data.results)
          // this.options = this.options.concat(res.data.data.results)
          this.entList = this.entList.concat(res.data.data.results)
        } else {
          this.$$message.error(res.data.msg)
        }
      })
      // console.log(88888)
    },
    onChoiceEnt(value) {
      this.num = 1
      this.entList = []
      this.remoteMethod()
      this.load()
      // this.entList =
      //   this.options.filter(item => {
      //     return item.creditCode == value
      //   }) || []
      // this.number = this.entList.length
      // this.$emit('getEntList', this.entList)
    },
    onChoice(val) {
      this.labelId = val || this.labelId
      this.remark = []
      this.num = 1
      this.labelList.map(k => {
        this.labelId.map(item => {
          if (k.id == item) {
            this.remark.push(k)
          }
        })
      })

      this.$emit('getLabelList', this.remark)
      this.$emit('getEnt', { entName: '', creditCode: '' })
      // this.key = null
      // this.options = []
      this.entList = []
      this.currentIndex = null
      this.remoteMethod()
      this.load()
    },
    onGoEnt(val, index) {
      this.currentIndex = index
      this.$emit('getEnt', { entName: val.entName, creditCode: val.creditCode })
    },
    // 移除标签项
    removeTagItem(val) {
      this.$emit('leftRemoveTag', val)
    },
    visibleChange(visible, refName) {
      if (visible) {
        const ref = this.$refs[refName]
        let popper = ref.$refs.popper
        if (popper.$el) popper = popper.$el
        if (
          !Array.from(popper.children).some(
            v => v.className === 'el-template-menu__list'
          )
        ) {
          const el = document.createElement('ul')
          el.className = 'el-template-menu__list'
          el.style =
            'border-top:2px solid rgb(64 158 255); padding:0; color:white;font-size: 14px;margin:0'
          el.innerHTML = `<li class=" text-center" style="height:50px;line-height: 50px;cursor: pointer;background:rgba(0, 127, 255, 0.7)">
            <span class="el-cascader-node__label">确 定</span>
            </li>`
          popper.appendChild(el)
          el.onclick = () => {
            // this.key = null
            // this.options = []
            // this.entList = []
            // this.currentIndex = null
            // this.remoteMethod()
          }
        }
      }
    }
  }
}
</script>
<style lang="scss">
.left-select {
  border: none;
  background: rgba(42, 95, 174, 0.9);
  margin-top: 0 !important;
  border-radius: 0;
  .popper__arrow {
    display: none;
  }
  .el-select-dropdown__item {
    height: 0.46rem;
    color: white;
    line-height: 0.46rem;
  }
  .selected {
    color: white !important;
    background: linear-gradient(to right, #004ea6, #3f8be2) !important;
  }
  .hover {
    color: white;
    background: linear-gradient(to right, #004ea6, #3f8be2) !important;
  }
  .el-select-dropdown__wrap {
    max-height: 460px;
  }
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  display: none;
}
::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
}
</style>
<style lang="scss" scoped>
.contain {
  width: 4.4rem;
  height: calc(100% - 0.6rem);
  .head {
    text-align: center;
    height: 0.6rem;
    line-height: 0.6rem;
    img {
      width: 100%;
    }
  }
  .box {
    margin-top: 0.3rem;
    width: inherit;
    height: 100%;
    background: url('~@/assets/images/left-entlist.png') no-repeat center center;
    background-size: 100% 100%;
    padding: 0.5rem 0.3rem 0;
    .box_head {
      line-height: 0.1rem;
      /deep/.el-select {
        width: 100%;
        .el-input__inner {
          background: transparent;
          border: 1px solid rgba(46, 178, 236, 0.5);
          min-height: 0.44rem;
          color: rgba(199, 241, 255, 100);
        }
      }
      /deep/.el-tag.el-tag--info {
        background-color: rgba(0, 127, 255, 0.5);
        border-color: rgba(0, 127, 255, 0.5);
        border-radius: 2px;
        color: rgba(199, 241, 255, 100);
        .el-tag__close {
          background: rgba(199, 241, 255, 1);
        }
      }
    }
    .box_text {
      // transform: translateY(-0.4rem);
      margin: 0.2rem 0;
      font-size: 0.16rem;
      color: rgba(0, 255, 254, 100);
    }
    .box_content {
      height: 90%;
      margin-top: 0.15rem;
      overflow: hidden;
      position: relative;
      /deep/ .el-input {
        width: 100%;
        // transform: translateY(-0.5rem);
        .el-select__input {
          color: rgba(199, 241, 255, 100);
        }
        .el-input__inner {
          background: transparent;
          border: 1px solid rgba(46, 178, 236, 0.5);
          height: 0.44rem !important;
          color: rgba(199, 241, 255, 100);
        }
        .el-input-group__append {
          background: #007fff;
          border: 1px solid #007fff;
          color: #fff;
          cursor: pointer;
        }
      }
      & > .box_content_view {
        // transform: translateY(-0.2rem);
        .infinite-list {
          height: 6.2rem;
          margin-bottom: 0.2rem;
        }
      }
      .box_content_ent {
        display: flex;
        align-items: center;
        cursor: pointer;
        padding: 0.11rem 0.16rem;
        margin-bottom: 0.15rem;
        &:nth-last-child(1) {
          margin-bottom: 0;
        }
        background: linear-gradient(
          to right,
          rgba(0, 114, 223, 0.3),
          rgba(0, 114, 223, 0)
        );
        font-size: 0.16rem;
        color: rgba(199, 241, 255, 100);
        > img {
          width: 0.16rem;
          height: 0.16rem;
          margin-right: 0.07rem;
          vertical-align: middle;
        }
        &.active {
          background: linear-gradient(
            to right,
            rgba(0, 114, 223, 1),
            rgba(0, 114, 223, 0)
          );
        }
      }
      & > .noList {
        margin-top: 1rem;
        text-align: center;
        color: rgba(199, 241, 255, 100);
        font-size: 14px;
        > img {
          width: 2.5rem;
          margin-bottom: 0.2rem;
        }
        & > div:nth-child(3) {
          margin-top: 0.1rem;
          color: #00fffe;
        }
      }
    }
  }
}
</style>
